export const API_VERSION = 'v1';

export const API_DOMAIN = process.env.REACT_APP_DOMAIN_API + API_VERSION;
export const API_V2_DOMAIN = process.env.REACT_APP_DOMAIN_API_V2;
export const REALTIME_ENDPOINT = process.env.REACT_APP_DOMAIN_REALTIME;
